<template>
  <div id="contenedor-auditoria-contratos-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar
          >
          </titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevoAuditoriaContratos="registrarNuevoAuditoriaContrato"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :listadoAuditoriaContratos="getAuditoriaContratos"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevoAuditoriaContratos"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <registrar-auditoria-contratos
      :idAuditoria="idAuditoria"
      v-if="mostrarVentanaRegistrarNuevoAuditoriaContratos"
      v-on:cerrar="cerrarRegistrarNuevoAuditoriaContratos"
      >
      </registrar-auditoria-contratos>
    </v-dialog>
    <!--
    <v-dialog
    persistent
    v-if="esteAuditoriaContratos"
      v-model="mostrarVentanaEditarAuditoriaContratos"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <editar-auditoria-contratos
        :auditoriaContratosEditar="esteAuditoriaContratos"
        v-on:cerrar="cerrarEditarAuditoriaContratos">
      </editar-auditoria-contratos>
    </v-dialog>
    -->
    <v-dialog
    v-if="esteAuditoriaContratos"
      v-model="mostrarVentanaEliminarAuditoriaContratos"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-auditoria-contratos
      :auditoriaContratosEliminar ="esteAuditoriaContratos"
      v-on:cerrar="cerrarEliminarAuditoriaContratos">
      </eliminar-auditoria-contratos>
    </v-dialog>
  </div>
</template>

<script>
import AUDITORIAS_CONTRATOS from '@/graphql/querys/administracion/auditorias/auditoriasContratos.gql';
// import EditarAuditoriaContratos
// from '@/components/administracion/auditorias/contratos/Editar.vue';
import RegistrarAuditoriaContratos from '@/components/administracion/auditorias/contratos/Nuevo.vue';
import EliminarAuditoriaContratos from '@/components/administracion/auditorias/contratos/Eliminar.vue';
import TituloToolBar from './TituloToolBar.vue';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'EntesFiscalizadoresDefault',
  components: {
    TituloToolBar,
    RegistrarAuditoriaContratos,
    // EditarAuditoriaContratos,
    EliminarAuditoriaContratos,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoAuditoriaContratos: false,
      // mostrarVentanaEditarAuditoriaContratos: false,
      mostrarVentanaEliminarAuditoriaContratos: false,
      esteAuditoriaContratos: null,
      idAuditoria: this.$route.params.idAuditoria,
      filtros: {
        buscarTexto: '',
      },
    };
  },
  apollo: {
    auditoriasContratos: {
      query: AUDITORIAS_CONTRATOS,
      variables() {
        return {
          idAuditoria: this.$route.params.idAuditoria,
        };
      },
    },
  },
  mounted() {
    eventBus.$on('eliminar-auditoria-contratos', (auditoriaContratos) => {
      this.esteAuditoriaContratos = auditoriaContratos;
      this.mostrarVentanaEliminarAuditoriaContratos = true;
    });
  },
  methods: {
    registrarNuevoAuditoriaContrato() {
      this.mostrarVentanaRegistrarNuevoAuditoriaContratos = true;
    },
    cerrarRegistrarNuevoAuditoriaContratos() {
      this.mostrarVentanaRegistrarNuevoAuditoriaContratos = false;
    },
    /*
    cerrarEditarAuditoriaContratos() {
      this.mostrarVentanaEditarEnteFiscalizador = false;
      this.esteAuditoriaContratos = null;
    },
    */
    cerrarEliminarAuditoriaContratos() {
      this.mostrarVentanaEliminarAuditoriaContratos = false;
      this.esteAuditoriaContratos = null;
    },
  },
  computed: {
    getAuditoriaContratos() {
      if (!this.auditoriasContratos) return [];
      return this.auditoriasContratos
        .map((contrato) => ({
          ejercicio: contrato.contrato.ejercicio,
          numero: contrato.contrato.numero,
          objeto: contrato.contrato.meta,
          contratista: contrato.contrato.contratista.nombreRazonSocial,
          ...contrato,
        }))
        .sort((a, b) => (`${a.numero}`).localeCompare(b.numero));
    },
  },
};
</script>
